<template>
  <div>
    <v-autocomplete
      v-model="selectedAllergens"
      :items="allergens"
      chips
      :label="$t('Select allergens')"
      multiple
      :value="selectedAllergens"
      return-object
    >
      >
      <template v-slot:selection="data">
        <v-chip
          outlined
          exact
          small
          close
          close-icon="mdi-close"
          v-bind="data.attrs"
          :input-value="data.name"
          @click="data.select"
          @click:close="remove(data.item)"
        >
          <v-avatar left>
            <v-img :src="data.item.image" />
          </v-avatar>
          {{ data.item.name }}
        </v-chip>
      </template>
      <template v-slot:no-data> <div /></template>

      <template v-slot:append-item>
        <template>
          <v-list-item-content>
            <v-btn color="primary" text @click="newAllergenDialog = true">
              Create new
            </v-btn>
          </v-list-item-content>
        </template>
      </template>
      <template v-slot:item="data">
        <v-list-item-avatar>
          <img :src="data.item.image" />
        </v-list-item-avatar>
        <v-list-item-content>
          <strong>
            <v-list-item-title colo>{{ data.item.name }}</v-list-item-title>
          </strong>
        </v-list-item-content>
      </template>
    </v-autocomplete>
    <v-dialog v-model="newAllergenDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">New Allergen</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="6">
                <v-text-field :label="$t('Name')" v-model="newAllergenName" />
              </v-col>
              <v-col cols="6">
                <!-- TODO Check js error for input -->
                <v-file-input
                  v-model="newAllergenIcon"
                  accept="image/png,image/jpeg,image/gif"
                  prepend-icon="mdi-camera"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="newAllergenDialog = false">
            {{ $t("Cancel") }}
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="
              createAllergen();
              newAllergenDialog = false;
            "
          >
            {{ $t("Save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Allergen from "@/model/allergen";
import { storage } from "@/firebase/firestore.js";

export default {
  name: "Allergens",

  props: ["productAllergens"],

  data() {
    return {
      newAllergenName: "",
      newAllergenIcon: "",
      newAllergenDialog: false,
      selectedAllergens: []
      // allergens: [
      //   {
      //     name: "gluten",
      //     image: require("@/assets/allergens/wheat_amber_50x50.png")
      //   },
      //   {
      //     name: "Huevos",
      //     image: require("@/assets/allergens/eggs_amber_50x50.png")
      //   },
      //   {
      //     name: "Lácteos",
      //     image: require("@/assets/allergens/milk_amber_50x50.png")
      //   },
      //   {
      //     name: "Pescado",
      //     image: require("@/assets/allergens/fish_amber_50x50.png")
      //   },
      //   {
      //     name: "Moluscos",
      //     image: require("@/assets/allergens/molluscs_amber_50x50.png")
      //   },
      //   {
      //     name: "Crustáceos",
      //     image: require("@/assets/allergens/crustacena_amber_50x50.png")
      //   },
      //   {
      //     name: "Cacahuetes",
      //     image: require("@/assets/allergens/peanut_amber_50x50.png")
      //   },
      //   {
      //     name: "Frutos secos",
      //     image: require("@/assets/allergens/treenut_amber_50x50.png")
      //   },
      //   {
      //     name: "Soja",
      //     image: require("@/assets/allergens/soya_amber_50x50.png")
      //   },
      //   {
      //     name: "Apio",
      //     image: require("@/assets/allergens/celery_amber_50x50.png")
      //   },
      //   {
      //     name: "Mostaza",
      //     image: require("@/assets/allergens/mustard_amber_50x50.png")
      //   },
      //   {
      //     name: "Sésamo",
      //     image: require("@/assets/allergens/sesame_amber_50x50.png")
      //   },
      //   {
      //     name: "Altramuz",
      //     image: require("@/assets/allergens/lupin_amber_50x50.png")
      //   },
      //   {
      //     name: "Sulfitos",
      //     image: require("@/assets/allergens/sulphurdioxide_amber_50x50.png")
      //   }
      // ],
    };
  },
  computed: {
    allergens() {
      return this.$store.getters.restaurant.allergens;
    }
  },
  methods: {
    async updateImage(name, file) {
      var imagesRef = storage.child(name);
      try {
        let snapshot = await imagesRef.putString(file, "base64");

        let downloadURL = await snapshot.ref.getDownloadURL();
        return downloadURL;
        // this.saving = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      } catch (error) {
        switch (error.code) {
          case "storage/unauthorized":
            //alert("unauthorized");
            break;
          case "storage/canceled":
            //alert("canceled");
            break;
          case "storage/unknown":
           // alert("unknown");
            break;
          default:
           // alert(error.code);
        }
      }
    },
    async createAllergen() {
      let id =
        "generated" +
        Math.random()
          .toString(36)
          .substring(2, 15) +
        Math.random()
          .toString(36)
          .substring(2, 15);
      if (this.newAllergenIcon != "") {
        let reader = new FileReader();
        reader.onload = async e => {
          let image = await this.updateImage(
            this.$store.getters.restaurant.id + "/images/" + id + "allergen",
            e.target.result.split(",")[1]
          );
          this.newAllergenIcon = image;
        };
        reader.readAsDataURL(this.newAllergenIcon);
      }
      let allergen = new Allergen({
        name: this.newAllergenName,
        icon: this.newAllergenIcon
      });
      this.$store.getters.restaurant.allergens.push(allergen);
      this.$store.getters.restaurant.save();
      this.newAllergenName = "";
      this.newAllergenIcon = "";
    },

    remove(item) {
      this.selectedAllergens = this.selectedAllergens.filter(
        allergen => allergen.name !== item.name
      );
    }
  },
  watch: {
    selectedAllergens: function() {
      this.$emit("updateAllergens", this.selectedAllergens);
    },
    productAllergens: function() {
      this.selectedAllergens = this.productAllergens;
    }
  }
};
</script>
